export default class KillPigConfigVO {
    public OpenKillPig: boolean = false;
    /**
     * 头部保留局
     */
    public HeaderReserveJuNumber: number = 1;
    /**
     * 搜索索引
     */
    public SearchStartIndex: number = 0;
    /**
     * 忽略局
     */
    public IgnoreJuNumber: number = 1;
    /**
     * 尾部保留局
     */
    public EndReserveJuNumber: number = 2;
    /**
     * 多少钱开始启用
     * 0不限制
     */
    public KillStartAmount: number = 0;
}